/* v8 ignore start */
import {LottieFileAssetModel} from "@/lib/lottie/assets/lottieFileAssetModel";

export class LottieImageAssetModel extends LottieFileAssetModel<LottieImageAssetModel.IJson> {
  public get id(): string {
    return this.json.id;
  }

  public get width(): number {
    if (!this.json.w) throw new Error("Width is not defined");

    return this.json.w;
  }

  public get height(): number {
    if (!this.json.h) throw new Error("Height is not defined");

    return this.json.h;
  }

  public get path(): Maybe<string> {
    return this.json.u;
  }

  public get source(): string {
    return this.json.p;
  }

  public get isBackground(): boolean {
    return this.type === "background";
  }

  public get isPhoto(): boolean {
    return this.type === "photo";
  }

  public get type(): Maybe<string> {
    return this.json.meta?.type;
  }

  public get isStatic(): boolean {
    return Boolean(this.json.meta?.isStatic);
  }
}

type TAssetType = "photo" | "background";

interface IMeta {
  uuid: string;
  type: TAssetType;
  isStatic?: boolean;
}

export namespace LottieImageAssetModel {
  export interface IJson extends LottieFileAssetModel.IJson {
    /**
     * Width of the image
     * @default 0
     */
    w?: number;

    /**
     * Height of the image
     * @default 0
     */
    h?: number;

    /**
     * Marks as part of an image sequence if present
     */
    t?: "seq";

    /**
     * One of the ID in the file's slots
     */
    sid?: string;

    /**
     * Custom Mixbook metadata field
     */
    meta?: IMeta;
  }
}
/* v8 ignore stop */
